import { makeRequest } from 'utils/requestLogger';

export default (page, filter, search, type) => {
  const query_params = {};

  if (page !== undefined) {
    query_params.page = page;
  }
  if (filter !== undefined) {
    query_params.filter = filter;
  }

  if (search !== undefined) {
    query_params.search = search;
  }

  if (type !== undefined) {
    query_params.type = type;
  }

  const query_string = new URLSearchParams(query_params).toString();

  return makeRequest('get', `/api/courses/participant?${query_string}`);
};


// WEBPACK FOOTER //
// ./src/app/services/courses/FetchParticipantCourses.js